// extracted by mini-css-extract-plugin
export default {"container":"NewProject_container__IvDZc"};